import React from 'react';
import Markdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import rehypeSanitize, { defaultSchema, type Options as SanitizeSchema } from 'rehype-sanitize';
import { safeMarkdownUrl } from '../../lib/markdown';
import { cn } from '../../lib/utils';

const sanitizeSchema: SanitizeSchema = {
  ...defaultSchema,
  tagNames: (defaultSchema.tagNames ?? []).filter(
    (tag) => tag !== 'img' && tag !== 'input' && tag !== 'picture' && tag !== 'source',
  ),
  protocols: {
    ...defaultSchema.protocols,
    href: ['http', 'https', 'mailto'],
    src: [],
  },
};

function MarkdownAnchor({ href, children }: { href?: string; children?: React.ReactNode }) {
  const safe = href ? safeMarkdownUrl(href) : '';
  if (!safe) return <span>{children}</span>;
  const external = safe.startsWith('http:') || safe.startsWith('https:');
  return (
    <a href={safe} {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
      {children}
    </a>
  );
}

export function MarkdownContent({ text, className }: { text: string; className?: string }) {
  if (!text.trim()) return null;

  return (
    <div className={cn('markdown-content', className)}>
      <Markdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[[rehypeSanitize, sanitizeSchema]]}
        urlTransform={safeMarkdownUrl}
        components={{
          a: MarkdownAnchor,
        }}
      >
        {text}
      </Markdown>
    </div>
  );
}
